module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('touch', {
    staticClass: "ranking",
    on: {
      "tap": _vm.gotoRanking
    }
  }), _vm._v(" "), _c('touch', {
    staticClass: "map",
    on: {
      "tap": _vm.gotoOverview
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('h4', [_vm._v("爱心"), _c('br'), _vm._v("地图")])]), _vm._v(" "), _c('div', {
    staticClass: "dial-plate"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('circle-progress', {
    staticClass: "plate",
    attrs: {
      "progress": _vm.total,
      "radius": 210,
      "strokeWidth": 4
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-bar"
  }, [_c('circle-progress', {
    staticClass: "total",
    attrs: {
      "progress": _vm.total,
      "radius": 165,
      "strokeWidth": 20
    }
  }), _vm._v(" "), _c('circle-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.remainingDuration > 0),
      expression: "remainingDuration > 0"
    }],
    staticClass: "current",
    attrs: {
      "progress": _vm.current,
      "radius": 165,
      "strokeWidth": 30
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('div', {
    staticClass: "overage"
  }, [_vm._v(_vm._s(_vm.remainingDuration))]), _vm._v(" "), _c('p', [_vm._v("剩余可捐赠时长")])])]), _vm._v(" "), _c('touch', {
    staticClass: "donate-btn",
    class: {
      active: _vm.canDonate
    },
    on: {
      "tap": _vm.donate
    }
  }, [_vm._v(_vm._s(_vm.donateText))]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.donateTip))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal"
  }, [_c('touch', {
    staticClass: "mask"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('love-map', {
    attrs: {
      "school": _vm.donationObjects,
      "current": _vm.donationObject
    }
  }), _vm._v(" "), _c('h4', [_vm._v("捐赠成功")]), _vm._v(" "), _c('p', [_vm._v("你刚刚成功捐赠了 " + _vm._s(_vm.donateCourse) + " 节课程！")]), _vm._v(" "), _c('p', [_vm._v("今日捐赠学校："), _c('strong', [_vm._v(_vm._s(_vm.donationObject))])])], 1), _vm._v(" "), _c('touch', {
    staticClass: "goto-overview",
    on: {
      "tap": _vm.openOverview
    }
  }, [_vm._v("查看我的爱心地图")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-51c0c91c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DonatePanel.vue
// module id = 204
// module chunks = 1